import { css } from '@emotion/react'

export default (theme) => css`
  :root {
    --ess-page-background: #f0f2f4;
    --ess-surface: #ffffff;
    --ess-border: #d9d9d9;
    --ess-radius: 15px;
    --ess-control-radius: 10px;
    --ess-field-radius: 4px;
    --ess-field-height: 32px;
    --ess-page-padding: 20px;
    --ess-panel-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
  }

  body {
    background: var(--ess-page-background);
  }

  .ant-layout {
    background: var(--ess-page-background);
  }

  .ant-card,
  .ant-modal-content {
    border-radius: var(--ess-radius);
    box-shadow: var(--ess-panel-shadow);
  }

  .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 12px;
  }

  .ant-tabs-tab {
    padding: 8px 0;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 20px;
  }

  .ant-btn {
    border-radius: var(--ess-control-radius);
    font-family: var(--font-primary);
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-picker,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: var(--ess-field-radius);
  }

  .ant-input-affix-wrapper > .ant-input {
    border-radius: 0;
  }

  .ant-btn:focus-visible,
  [role='tab']:focus-visible {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
  }

  @media (max-width: 767px) {
    :root {
      --ess-page-padding: 12px;
    }

    .ant-tabs-extra-content .ant-space {
      flex-wrap: wrap;
    }
  }

  hr {
    opacity: 0.1;
    border: 1px solid;
    width: 100%;
    border-color: ${theme.common.textColor};
  }
`
